<div class="zugang-screen">
  <div class="zugang-logo" aria-label="SaniUp"></div>

  <div class="zugang-kopf">
    <mat-icon class="zugang-kopf__icon">how_to_reg</mat-icon>
    <h1 class="mat-headline-small">Dein Zugang ist noch nicht freigeschaltet</h1>
    <p class="mat-body-medium muted">
      Dein Konto wurde mit der Anmeldung angelegt. Es hat aber noch keine Rolle. Bis die vergeben ist, bleibt SaniUp ONE leer.
    </p>
  </div>

  <lib-outlined-card outlineWidth="1px" class="zugang-karte">
    <mat-card>
      <mat-card-content>
        <h2 class="mat-title-medium">Das muss noch passieren</h2>
        <ol class="schritte mat-body-medium">
          <li>
            Eine Kollegin oder ein Kollege in deinem Sanitätshaus, die oder der SaniUp ONE schon nutzt, öffnet die Benutzerverwaltung (<span
              class="pfad"
              >Einstellungen → Benutzer:innen</span
            >).
          </li>
          <li>
            Dort steht dein Konto in der Liste. In der Spalte <span class="pfad">Rollen</span> die Rolle „Leistungserbringer" auswählen.
          </li>
          <li>Fertig — dieser Bildschirm merkt es von selbst und schaltet weiter. Neu anmelden musst du dich nicht.</li>
        </ol>
      </mat-card-content>
    </mat-card>
  </lib-outlined-card>

  <lib-outlined-card outlineWidth="1px" class="zugang-karte">
    <mat-card>
      <mat-card-content>
        <h2 class="mat-title-medium">Zum Weiterschicken</h2>

        <div class="feld">
          <span class="mat-label-small muted">Link zur Benutzerverwaltung</span>
          <div class="feld__zeile">
            <span class="feld__wert mat-body-medium">{{ benutzerverwaltungLink }}</span>
            <button type="button" matIconButton [cdkCopyToClipboard]="benutzerverwaltungLink" aria-label="Link kopieren">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>

        <div class="feld">
          <span class="mat-label-small muted">Dein Konto</span>
          <div class="feld__zeile">
            <span class="feld__wert mat-body-medium">{{ email() }}</span>
            <button type="button" matIconButton [cdkCopyToClipboard]="email()" aria-label="E-Mail-Adresse kopieren">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        </div>

        <button type="button" matButton="filled" class="nachricht-knopf" [cdkCopyToClipboard]="nachricht()">
          <mat-icon>mail</mat-icon>
          Fertige Nachricht kopieren
        </button>
        <p class="mat-body-small muted">
          Kopiert eine kurze Nachricht mit Link und deiner Adresse. Schick sie einfach an die Kollegin oder den Kollegen.
        </p>
      </mat-card-content>
    </mat-card>
  </lib-outlined-card>

  <div class="zugang-aktionen">
    <button type="button" matButton="outlined" [disabled]="pruefungLaeuft()" (click)="jetztPruefen()">
      <mat-icon>refresh</mat-icon>
      {{ pruefungLaeuft() ? 'Wird geprüft…' : 'Jetzt prüfen' }}
    </button>
    <button type="button" matButton (click)="logout()">Abmelden</button>
  </div>

  <!-- Statt „Support kontaktieren" als mailto-Knopf in der Reihe: hier sitzt jemand fest und
       braucht die Nummer, nicht ein Mailprogramm. -->
  <app-support-card
    class="zugang-support"
    titel="Kommst du nicht weiter?"
    betreff="Zugang zu SaniUp ONE"
    text="Hallo SaniUp-Team,&#10;&#10;mein Zugang zu SaniUp ONE ist noch nicht freigeschaltet.&#10;&#10;Viele Grüße"
  />

  <p class="mat-body-small muted zugang-fuss">
    @if (automatikLaeuft()) {
      Diese Seite prüft im Hintergrund weiter. Du kannst sie einfach offen lassen.
    } @else {
      Die automatische Prüfung pausiert. Tippe auf „Jetzt prüfen", um sie fortzusetzen.
    }
  </p>
</div>
